import { SHOW_DOCUMENT_FORM, HIDE_DOCUMENT_FORM, SHOW_DOCUMENT_PREVIEW, HIDE_DOCUMENT_PREVIEW } from './types'

export const showDocumentForm = (data) => ({
  type: SHOW_DOCUMENT_FORM,
  data
});

export const hideDocumentForm = () => ({
  type: HIDE_DOCUMENT_FORM
});

export const showDocumentPreview = (data) => ({
  type: SHOW_DOCUMENT_PREVIEW,
  data
});

export const hideDocumentPreview = () => ({
  type: HIDE_DOCUMENT_PREVIEW
});